export const mockCreditLimitSuccessResponse = {
  creditLimit: '7100',
  fullApproval: true,
};

export const mockCreditLimitPartialResponse = {
  creditLimit: '7100',
  fullApproval: false,
};

export const mockCreditLimitReferredResponse = {
  data: {
    response: {
      status: 422,
      data: {
        code: 'application.businessError',
        message: 'Encountered Business Error',
        trackingId: '2830c855-ebd0-439b-b34a-da120be8a687',
        documentationUrl: '',
        remediationInfo: '',
        transient: true,
        debugInfo: {},
        businessErrors: [
          {
            code: '600019',
            message: 'Please contact customer service for more details',
          },
        ],
      },
    },
  },
};

export const mockCreditLimitDeniedResponse = {
  data: {
    response: {
      status: 422,
      data: {
        code: 'application.businessError',
        message: 'Encountered Business Error',
        trackingId: '2830c855-ebd0-439b-b34a-da120be8a687',
        documentationUrl: '',
        remediationInfo: '',
        transient: true,
        debugInfo: {},
        businessErrors: [
          {
            code: '600020',
            message:
              'Your request was denied and you will receive a letter in 7-10 business days',
          },
        ],
      },
    },
  },
};

export const mockCreditLimitUnhandledResponse = {
  data: {
    response: {
      status: 422,
      data: {
        code: 'application.businessError',
        message: 'Encountered Business Error',
        trackingId: '2830c855-ebd0-439b-b34a-da120be8a687',
        documentationUrl: '',
        remediationInfo: '',
        transient: true,
        debugInfo: {},
        businessErrors: [
          {
            code: '600001',
            message:
              'Your request was denied and you will receive a letter in 7-10 business days',
          },
        ],
      },
    },
  },
};

export const mockCreditLimitBadRequest = {
  data: {
    response: {
      status: 500,
      code: 'gateway.client.badRequest',
      message: 'string',
      trackingId: '11da8ffa-5f8a-4202-94e0-570fbacb050a',
      documentationUrl: 'string',
      remediationInfo: 'string',
      transient: true,
      debugInfo: {},
    },
  },
};
